import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { ReactComponent as QuoteOpen } from "../../../assets/images/quote-sx.svg";
import { ReactComponent as QuoteClose } from "../../../assets/images/quote-dx.svg";

import shareIcon from "../../../assets/images/share.png";
import closeIcon from "../../../assets/images/close.png";
import fotoDirigenti from "../../../assets/images/dirigenti-foto-cerchio.webp";
import firmaPres from "../../../assets/images/firma-pres.png";
import firmaGm from "../../../assets/images/firma-gm.png";
import bkg from "../../../assets/images/bkg-beige.png";

export default function Sezione2popup1EN({ isOpen, onClose }) {
  const overlayRef = useRef(null);

  // ESC + blocco scroll quando il popup è aperto
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose?.();
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      window.removeEventListener("keydown", onKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const onShare = (popupId) => {
  const url = new URL(window.location.href);
  url.searchParams.set("popup", popupId);

  if (navigator.share) {
    navigator
      .share({ title: "Letters to the Stakeholders", url: url.toString() })
      .catch(() => {});
  } else if (navigator.clipboard) {
    navigator.clipboard.writeText(url.toString()).catch(() => {});
  }
  };

  return createPortal(
    <div
      ref={overlayRef}
      className="fixed inset-0 z-[999] bg-black/50 backdrop-blur-[2px] flex items-center justify-center p-3 md:p-6"
      onMouseDown={(e) => {
        if (e.target === overlayRef.current) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
      aria-label="Letters to the Stakeholders"
    >
      <div
        className="
          relative
          bg-white shadow-2xl
          max-h-[90vh] w-full md:w-[1280px] overflow-y-auto overscroll-contain
        "
        // sfondo
        style={{
             backgroundImage: `url(${bkg})`,
            backgroundRepeat:'no-repeat',
            backgroundPosition:'right bottom',
            backgroundSize:'cover'
        }}
      >
        {/* Azioni in alto a destra: badge, share, X */}
        <div className="absolute right-3 top-3 flex items-center gap-2 z-2">
          <button
            onClick={() => onShare("Sezione2popup1")}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] hover:bg-[#fff] hover:text-white border border-transparent hover:border-[#0E3761] transition"
            title="Condividi"
            aria-label="Condividi"
          >
            {shareIcon ? <img src={shareIcon} alt="" className="h-4 w-4" /> : "↗"}
          </button>
          <button
            onClick={onClose}
            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-[#0E3761] hover:bg-[#fff] hover:text-white border border-transparent hover:border-[#0E3761] transition"
            title="Chiudi"
            aria-label="Chiudi"
          >
            {closeIcon ? <img src={closeIcon} alt="Chiudi" className="h-4 w-4" /> : "✕"}
          </button>
        </div>

        {/* Contenuto */}
        <div className="py-8 px-5 md:px-8">

          {/* Immagine circolare flottante: il testo scorre attorno (shape-outside) */}
          <img
            src={fotoDirigenti}
            alt="Chairman and General Manager of Reale Group"
            className="mx-auto md:mx-0 md:float-left w-[240px] md:w-[440px] h-auto mb-5 md:mb-2 md:mr-10"
            style={{ shapeOutside: "circle(200px at 210px 210px)", shapeMargin: "30px", marginLeft: "-20px", marginTop: "-20px" }}
          />

          {/* Testo della lettera (scorre attorno al cerchio) */}
          <QuoteOpen className="w-6 h-6 inline-block align-top ml-0 md:ml-12 flex-shrink-0" />
          <p className="text-[16px] md:text-[24px] mt-4">
            Dear Stakeholders,
          </p>
          <p className="text-[16px] md:text-[24px] mt-4">
            These Integrated Consolidated Financial Statements encapsulate a year
            of significant achievements and complexities. Despite the challenging
            geopolitical and macroeconomic backdrop of 2025, Reale Group
            demonstrated its strength by confirming that a model based on mutuality
            and sustainability can generate lasting value for its members and the
            communities in which it operates.
          </p>

          {/* Paragrafi */}
          <div className="mt-4 space-y-4">
                <p className="text-[16px] md:text-[24px]">
                    This is not a foregone conclusion. It is the result of our people&rsquo;s daily efforts, the
                    consistent implementation of strategic choices and the ongoing trust placed in
                    the Group by our Members/Policyholders, Customers and Partners.
                </p>
                <p className="text-[16px] md:text-[24px]">
                    Our mutual insurance identity and our status of Benefit Corporation are the
                    cornerstones of all our actions. Living in a &ldquo;home for all&rdquo; means putting the
                    well-being of individuals and the development of local communities at the
                    heart of everything we do. We believe that mutuality is a modern model that
                    can transform value into shared protection. In this spirit, sustainability is a
                    fundamental value for us, fostering a sense of belonging. We have chosen to
                    integrate ESG impact as a key variable in our strategies and decisions, and
                    we measure the Company&rsquo;s success by the tangible benefits it creates for the
                    community.
                </p>
                <p className="text-[16px] md:text-[24px]">
                    Looking to the future, our goal is to become a constant and reassuring presence
                    in people&rsquo;s lives. The evolution towards a healthy ecosystem, strengthened by
                    key acquisitions such as Lifenet, enables us to support Members/Policyholders
                    and Customers from prevention to treatment, including protection. This
                    approach supports the idea of healthcare as a common good centred on the
                    individual. At the same time, our commitment to the housing sector is helping
                    to drive the energy transition. Through the development of energy communities
                    and real estate efficiency, we aim to protect the environment and ensure that
                    future generations enjoy the same high quality of life.
                </p>
                <p className="text-[16px] md:text-[24px]">
                    Technological innovation and artificial intelligence are powerful drivers of change
                    and transformation. We take an ethical approach to these developments, aiming
                    to enhance human talent and raise our standards. As we approach our
                    two-hundred-year anniversary, we are aiming to consolidate our presence by bringing
                    our values to new international markets.
                </p>
                <p className="text-[16px] md:text-[24px]">
                    Thanks to our financial strength and team spirit, we are ready to face the
                    evolutions of the sector with serenity. We will continue to dedicate ourselves to
                    caring for people, remaining faithful to our purpose: &ldquo;Taking care of people for a
                    better world, together&rdquo;.
                </p>
                <p className="text-[16px] md:text-[24px] mt-4 flex items-end gap-2">
                  <span>We wish for a fulfilling and growth-filled journey for all of us.</span>
                  <QuoteClose className="w-6 h-6 flex-shrink-0" />
                </p>
              </div>

              {/* fine del flusso attorno al cerchio */}
              <div className="clear-both" />

              {/* Firme */}
              <div className="mt-10 flex flex-col md:flex-row md:justify-between gap-8">
                <div className="flex flex-col items-start">
                  <div className="font-semibold text-[#0E3761]">Luigi Lana</div>
                  <div className="text-sm text-[#0E3761]">Chairman of Reale Mutua</div>
                  <img
                    src={firmaPres}
                    alt="Signature Luigi Lana"
                    className="h-12 md:h-14 object-contain mt-2"
                  />
                </div>
                <div className="flex flex-col items-start md:items-end">
                  <div className="font-semibold text-[#0E3761]">Luca Filippone</div>
                  <div className="text-sm text-[#0E3761]">Group &amp; RMA General Manager</div>
                  <img
                    src={firmaGm}
                    alt="Signature Luca Filippone"
                    className="h-12 md:h-14 object-contain mt-2"
                  />
                </div>
              </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
